import { AST, ProgDecl } from "./ir/ast";
import { ASTVisitor } from "./ASTVisitor";
import {
    getBuiltInCommandStructure,
    getSpecialBuiltInCommandStructure,
} from "./ir/builtInCommands";
import { XLogoSemanticError, SemanticErrorCause } from "./semanticError";
import { SemanticResult } from "./semanticVerifier";

export class ProgDeclVerifier extends ASTVisitor<void, XLogoSemanticError[]> {
    // Global scope containing all defined programs with valid names
    private definedPrograms: Map<string, ProgDecl> = new Map<
        string,
        ProgDecl
    >();

    constructor() {
        super();
    }

    public check(
        input: AST | AST[],
        context: Map<string, ProgDecl> | undefined,
    ): SemanticResult {
        let errors: XLogoSemanticError[] = [];

        let inputArr: AST[];

        if (input instanceof AST) {
            inputArr = [input];
        } else {
            inputArr = input;
        }

        inputArr.forEach(ast => {
            const astErrors = this.visit(ast, undefined);
            errors = errors.concat(astErrors);
        });

        return { errors: errors, correctPrograms: this.definedPrograms };
    }

    protected defaultResult(): XLogoSemanticError[] {
        // Per default there are no semantic errors
        return [];
    }

    protected aggregateResult(
        aggregate: XLogoSemanticError[],
        nextResult: XLogoSemanticError[],
    ): XLogoSemanticError[] {
        // Concatenate lists such that all errors of all children are in the list
        return aggregate.concat(nextResult);
    }

    public visitProgDecl(ast: ProgDecl, arg: void): XLogoSemanticError[] {
        let errors: XLogoSemanticError[] = [];
        if (this.definedPrograms.get(ast.name)) {
            // Test if already defined
            errors.push(
                new XLogoSemanticError(
                    SemanticErrorCause.DOUBLE_DECLARATION_PROGRAM_NAME,
                    ast,
                    {},
                ),
            );
        } else if (getBuiltInCommandStructure(ast.name)) {
            // Test if name is a built in name
            errors.push(
                new XLogoSemanticError(
                    SemanticErrorCause.INVALID_PROGRAM_NAME,
                    ast,
                    {},
                ),
            );
        } else if (getSpecialBuiltInCommandStructure(ast.name)) {
            // Test if name is a built in name
            errors.push(
                new XLogoSemanticError(
                    SemanticErrorCause.INVALID_PROGRAM_NAME,
                    ast,
                    {},
                ),
            );
        } else {
            // Everything ok
            this.definedPrograms.set(ast.name, ast);
        }
        return errors;
    }
}



// WEBPACK FOOTER //
// ./src/app/xlogo-parser/progDeclVerifier.ts